module.exports = __webpack_public_path__ + "img/Kibe48.bad5942b.jpg";